export var TOPICS = {
  ON_ODDS_FORMAT_CHANGE: 'onOddsFormatChanged'
};